<template>
  <div
    style="cursor: pointer"
    :style="{
      animation: option.attribute.autoRotate
        ? 'rotate ' + option.attribute.rotateDuration + 's infinite linear'
        : null,
      width: current.cptWidth + 'px',
      height: current.cptHeight + 'px',
    }"
    @click.stop="scanClick"
  >
    <t-image
      style="width: 100%; height: 100%; z-index: 0"
      :style="{ background: option.attribute.bgColor || 'none' }"
      :src="
        option.attribute.url
          ? fileUrl + option.attribute.url
          : require('@/assets/scan.png')
      "
      :fit="option.attribute.fit"
    />
  </div>
</template>

<script>
import { fileUrl } from "/env";
export default {
  name: "cpt-scan",
  props: {
    option: Object,
    current: Object,
    refMap: Object,
  },
  data() {
    return {
      fileUrl,
    };
  },
  mounted() {
    window.EWMCallBack = this.EWMCallBack.bind(this);
  },
  created() {},
  methods: {
    scanClick() {
      console.log(this.isMobile(), "this.isMobile()");
      if (this.isMobile()) {
        let pageObjName = this.option.interaction.eventList[0].paramData.reduce(
          (accumulator, currentItem) => ({
            ...accumulator,
            [currentItem.targetTitle]: "",
          }),
          {}
        );
        window.Android.startQrcodeScannerSB(pageObjName, "EWMCallBack");
      } else {
        console.log("当前不处于移动设备环境下");
      }
    },
    isMobile() {
      // 使用正则表达式匹配常见的移动设备标识符
      const ua = navigator.userAgent;
      return /mobile|phone|android|iemobile/i.test(ua);
    },
    EWMCallBack(jsonStr, pageObjName) {
      let jsonObject = JSON.parse(jsonStr);
      console.log(jsonObject, "jsonObject");
      // let obj =  {"url":"https://www.xdwater365.com/yhfw","orgCode":"xdkj","orgNAME":"演示机构","COMM_ORG_IDENTY":"1000"};
      if (
        this.option &&
        this.option.interaction &&
        Array.isArray(this.option.interaction.eventList) &&
        this.option.interaction.eventList.length > 0 &&
        Array.isArray(this.option.interaction.eventList[0].paramData)
      ) {
        this.option.interaction.eventList[0].paramData.forEach((item) => {
          if (this.refMap[item.to]) {
            const targetKey = item.targetTitle;
            const targetValue = jsonObject[targetKey];
            // 动态调用并设置值
            this.refMap[item.to].setValue(targetValue);
          }
        });
      }
    },
  },
  beforeDestroy() {
    // 可以选择在组件销毁前从 window 上移除该方法，避免内存泄漏
    delete window.EWMCallBack;
  },
};
</script>

<style>
@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
